import { ReactNode } from 'react';
import { isNil } from 'lodash';
import { Box, BoxProps } from '@mui/material';

import { NO_DATA_PLACEHOLDER } from '@occc-app/design-system/constants';
import { Tooltip } from '@occc/ui-design-system';

import { InfoFieldValue } from './info-field-value.component';
import { Typography } from '../Typography';
import { MutedContent } from '../MutedContent';

export type InfoFieldProps = {
  label: ReactNode;
  value?: string | number | ReactNode;
  noDataMessage?: string;
  disableTypography?: boolean;
  truncate?: boolean;
} & BoxProps;

export const InfoField = ({
  label,
  value: propValue,
  noDataMessage = NO_DATA_PLACEHOLDER,
  disableTypography: propDisableTypography,
  truncate,
  ...restProps
}: InfoFieldProps) => {
  let value = propValue;
  let disableTypography = propDisableTypography;
  if (isNil(propValue) || propValue === '') {
    value = <MutedContent>{noDataMessage}</MutedContent>;
    disableTypography = true;
  }

  return (
    <Box {...restProps}>
      <Typography variant='body2' color='textSecondary' gutterBottom>
        {label}
      </Typography>

      {truncate ? (
        <Tooltip title={value}>
          <Box
            component='span'
            sx={{
              maxWidth: '100%',
              minWidth: 0,
              display: 'display-block',
            }}
          >
            <InfoFieldValue value={value} disableTypography={disableTypography} truncate />
          </Box>
        </Tooltip>
      ) : (
        <InfoFieldValue value={value} disableTypography={disableTypography} />
      )}
    </Box>
  );
};
